import React, { useState } from 'react'
import { Form } from 'antd'
import { useNavigate } from 'react-router-dom';
import Authouterpage from '../../components/authouterpages/authouterpage';

const Resetpassword = () => {
	// eslint-disable-next-line
	const [form] = Form.useForm();
	// eslint-disable-next-line
	const navigate = useNavigate()

	// eslint-disable-next-line
	const [loading, setLoading] = useState(false)
	// eslint-disable-next-line
	const [error, setError] = useState<any>(null)
	// eslint-disable-next-line
	const [errors, setErrors] = useState({
		email: '',
	})

	return (
		<Authouterpage
			isPasswordRelated
		>
			<div>
				<div className='mx-auto mt-[6.3rem] bg-appcolorwhite rounded-[20px] w-[40%] custom-box-shadow-seven px-[1.8rem] py-[1.6rem]'>
					<div className='flex border-b border-appcolorgreyfour pb-[1.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Reset Password</h1>
					</div>
				</div>
			</div>
		</Authouterpage>
	)
}

export default Resetpassword